const newContainer = () => import("@/layouts/Default.vue");
const routerParrent = () => import("@/layouts/routerParrent.vue");
const researchList = () =>
  import("../views/researchList/searchResearchList.vue");

const myResearchesList = () =>
  import("../views/myResearches/MysearchResearchList.vue");

const editSearch = () =>
  import("../views/researchList/components/editPlane.vue");

const researchManagerConnectionSearch = () =>
  import("../views/readyToResearch/researchManagerConnectionSearch.vue");

const researchManagerResearcher = () =>
  import(
    "../views/researchManagerResearcher/searchResearchManagerResearcher.vue"
  );

const myResearcher = () => import("../views/myResearcher/searchResearcher.vue");

export const researchRoutes: any[] = [
  {
    path: "/new-research",
    name: "research",
    meta: {
      label: "خانه",
      redesigned: true,
      moduleName: "research",
    },
    component: newContainer,
    children: [
      {
        path: "assign-research-manager-to-researcher",
        name: "assign_research_manager_to_researcher",
        meta: {
          label: "تحقیق",
          requiresAuth: true,
          redesigned: true,
        },
        redirect: "/new-research/assign-research-manager-to-researcher/list",
        component: routerParrent,
        children: [
          {
            path: "list",
            name: "assign-research-manager-to-researcher-list",
            component: researchManagerResearcher,
            meta: {
              label: "ارتباط مدیر تحقیق با ارزیاب تحقیقات",
              requiresAuth: true,
              redesigned: true,
            },
          },
        ],
      },
      {
        path: "ready-research",
        name: "ready_research",
        meta: {
          label: "تحقیق",
          requiresAuth: true,
          redesigned: true,
        },
        redirect: "/new-research/ready-research/list",
        component: routerParrent,
        children: [
          {
            path: "list",
            name: "ready-research-list",
            component: researchManagerConnectionSearch,
            meta: {
              label: "آماده تحقیق",
              requiresAuth: true,
              redesigned: true,
            },
          },
        ],
      },
      {
        path: "my_research",
        name: "my_research",
        meta: {
          label: "تحقیقات من",
          requiresAuth: true,
          redesigned: true,
        },
        redirect: "/new-research/my_research/search",
        component: routerParrent,
        children: [
          {
            path: "search",
            name: "my_research_queue",
            component: myResearchesList,
            meta: {
              label: "تحقیقات من",
              requiresAuth: true,
              redesigned: true,
            },
          },
        ],
      },

      {
        path: "my_researcher",
        name: "researcher",
        meta: {
          label: "ارزیاب‌های من",
          requiresAuth: true,
          redesigned: true,
        },
        redirect: "/new-research/my_researcher/search",
        component: routerParrent,
        children: [
          {
            path: "search",
            name: "my_researcher",
            component: myResearcher,
            meta: {
              label: "ارزیاب‌های من",
              requiresAuth: true,
              redesigned: true,
            },
          },
        ],
      },
      {
        path: "inner_research",
        name: "research_queue",
        meta: {
          label: "تحقیق",
          requiresAuth: true,
          redesigned: true,
        },
        redirect: "/new-research/inner_research/search",
        component: routerParrent,
        children: [
          {
            path: "search",
            name: "research_list",
            component: researchList,
            meta: {
              label: "لیست تحقیق",
              requiresAuth: true,
              redesigned: true,
            },
          },
          {
            path: "researchPlan/:code",
            name: "research_plan_search",
            component: editSearch,
            meta: {
              label: "عملیات تحقیق",
              requiresAuth: true,
              redesigned: true,
              hasBottomNavigation: false,
            },
          },
        ],
      },
    ],
  },
];
